import React from 'react';
import { CheckIcon, ArrowRightIcon } from 'lucide-react';
import { trackLead } from './MetaPixel';
export function ClosingSection() {
  const handleCTA = () => {
    trackLead();
    const baseUrl = 'https://closerdigital.net/F/NLeon2';
    const utmParams = '?utm_source=facebook&utm_medium=cpc&utm_campaign={{campaign.name}}&utm_adset={{adset.name}}&utm_ad={{ad.name}}&utm_content={{ad.id}}&ref=alexa';
    window.location.href = baseUrl + utmParams;
  };
  const includes = ['Certificación completa como Closer Digital', 'Acceso de por vida al sistema y actualizaciones', 'Soporte directo del equipo de Alexa Narvaez', 'Comunidad privada de closers élite', 'Plantillas y scripts probados', 'Casos de estudio y llamadas en vivo'];
  return <section className="relative w-full bg-gradient-to-br from-[#0D0D0D] via-[#1C1C1C] to-[#0D0D0D] py-12 md:py-32 px-4 md:px-6 overflow-hidden" data-id="element-87">
      <div className="absolute inset-0 opacity-10" data-id="element-88">
        <div className="absolute top-0 left-0 w-48 md:w-96 h-48 md:h-96 bg-[#D4AF37] blur-3xl rounded-full" data-id="element-89"></div>
        <div className="absolute bottom-0 right-0 w-48 md:w-96 h-48 md:h-96 bg-[#FF4F75] blur-3xl rounded-full" data-id="element-90"></div>
      </div>
      <div className="relative max-w-5xl mx-auto" data-id="element-91">
        <div className="text-center mb-8 md:mb-16" data-id="element-92">
          <h2 className="font-['Playfair_Display'] text-3xl md:text-5xl lg:text-7xl font-bold text-white mb-4 md:mb-6 leading-tight px-4" data-id="element-93">
            Este es tu momento. <br data-id="element-94" />
            <span className="text-[#D4AF37]" data-id="element-95">No lo dejes pasar.</span>
          </h2>
          <div className="w-24 md:w-32 h-1 bg-gradient-to-r from-[#FF4F75] to-[#D4AF37] mx-auto my-4 md:my-10" data-id="element-96"></div>
        </div>
        <div className="bg-gradient-to-br from-[#1C1C1C] to-[#0D0D0D] p-6 md:p-12 lg:p-16 rounded-2xl md:rounded-3xl border-2 border-[#D4AF37]/30 shadow-2xl mb-6 md:mb-12" data-id="element-97">
          <h3 className="font-['Playfair_Display'] text-xl md:text-3xl lg:text-4xl font-bold text-white text-center mb-6 md:mb-12" data-id="element-98">
            Tu Camino Hacia la Transformación
          </h3>
          <div className="space-y-2 md:space-y-4 mb-6 md:mb-12" data-id="element-99">
            <h4 className="font-['Playfair_Display'] text-lg md:text-2xl font-bold text-white mb-3 md:mb-6" data-id="element-100">
              Incluye:
            </h4>
            {includes.map((item, index) => <div key={index} className="flex items-start gap-2 md:gap-4" data-id="element-101">
                <div className="w-5 h-5 md:w-6 md:h-6 bg-[#D4AF37] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 md:mt-1" data-id="element-102">
                  <CheckIcon className="w-3 h-3 md:w-4 md:h-4 text-[#0D0D0D]" data-id="element-103" />
                </div>
                <p className="font-['Inter'] text-gray-200 text-sm md:text-base lg:text-lg" data-id="element-104">
                  {item}
                </p>
              </div>)}
          </div>
          <div className="text-center" data-id="element-105">
            <p className="font-['Inter'] text-[#FF4F75] text-xs md:text-base mb-4 md:mb-8 italic px-4" data-id="element-106">
              Solo aceptamos nuevas aplicaciones por cohorte.
            </p>
            <button onClick={handleCTA} className="group inline-flex items-center gap-2 px-8 md:px-10 py-3.5 md:py-4 bg-gradient-to-r from-[#FF4F75] to-[#D4AF37] rounded-full font-['Montserrat'] font-bold text-base md:text-lg text-white transition-all duration-300 hover:scale-105 hover:shadow-[0_0_40px_rgba(212,175,55,0.5)]" data-id="element-107">
              <span data-id="element-108">Ver el Entrenamiento Ahora</span>
              <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" data-id="element-109" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}